exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ld-error {\n  border: 1px solid #B03060 !important;\n}\n\n.preview {\n  position: relative;\n}\n\n.picture {\n  width: auto;\n  height: 100px;\n  margin-left: 1em;\n  border: 1px solid black;\n}\n\n.remove-picture {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 1px;\n  border-radius: 0;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/event-form/event-form.component.css
// module id = 846
// module chunks = 0